import { useNavigate, useSearchParams } from 'react-router';

import {
  ANNOTATION_SETS_VIEW,
  ANNOTATION_VIEW_PARAM,
  SOURCE_VERSION_PARAM,
  annotationSetsPath,
  annotationWorkspacePath,
} from './AnnotationEditor/index.js';
import { AnnotationSetsManager } from './AnnotationSetsManager.js';
import { AnnotationWorkspace } from './AnnotationWorkspace.js';
import type { DatasetAnnotationsTabProps } from './DatasetAnnotationsTab.interface.js';
import { useStyles } from './DatasetAnnotationsTab.style.js';

/**
 * Annotations tab shell. Defaults to the two-pane annotate workspace (file
 * picker + labeling editor) and switches to the annotation-set manager
 * (create / upload / download) on demand. A scoped data entry (e.g. from the
 * Data tab's "Annotate") always lands in the workspace.
 */
export function DatasetAnnotationsTab({
  annotationContent,
  dataSetId,
  datasetName,
  dataSetVersion,
  dataSetStatus,
  myRoles,
  scopedDataId,
  scopedFileId,
}: DatasetAnnotationsTabProps) {
  const styles = useStyles();
  const navigate = useNavigate();
  const [search] = useSearchParams();
  const requestedVersion = Number(search.get(SOURCE_VERSION_PARAM));
  const sourceVersion =
    annotationContent !== undefined &&
    Number.isSafeInteger(requestedVersion) &&
    requestedVersion > 0
      ? requestedVersion
      : dataSetVersion;
  const showSets =
    annotationContent === undefined &&
    scopedDataId === undefined &&
    search.get(ANNOTATION_VIEW_PARAM) === ANNOTATION_SETS_VIEW;

  return (
    <div className={styles.editorRoot}>
      {showSets ? (
        <AnnotationSetsManager
          dataSetId={dataSetId}
          datasetName={datasetName}
          dataSetVersion={dataSetVersion}
          dataSetStatus={dataSetStatus}
          myRoles={myRoles}
          onBack={() => void navigate(annotationWorkspacePath(dataSetId))}
        />
      ) : (
        <AnnotationWorkspace
          annotationContent={annotationContent}
          dataSetId={dataSetId}
          datasetName={datasetName}
          dataSetVersion={sourceVersion}
          myRoles={myRoles}
          scopedDataId={scopedDataId}
          scopedFileId={scopedFileId}
          onManageSets={() => void navigate(annotationSetsPath(dataSetId))}
        />
      )}
    </div>
  );
}
